<template>
  <section class="carousel-container">
    <div class="relative" :style="{ height: isMobile ? '300px' : '500px' }">
      <!-- 轮播容器 -->
      <div ref="carouselContainer" class="carousel-wrapper overflow-hidden w-full h-full relative">
        <!-- 轮播项 -->
        <div class="carousel-items flex transition-transform duration-500 ease-in-out" :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
          <!-- 轮播项1 - 云宽带 -->
          <div class="carousel-item w-full h-full flex-shrink-0">
            <div class="relative h-full bg-gradient-to-r from-purple-900 to-blue-900">
              <div class="absolute inset-0 overflow-hidden">
                <div class="absolute inset-0 bg-black opacity-30"></div>
                <img
                  src="https://picsum.photos/seed/cloud-broadband/1920/1080.jpg"
                  alt="云宽带"
                  class="w-full h-full object-cover"
                />
              </div>
              <div class="container mx-auto px-4 h-full flex items-center relative z-10">
                <div class="max-w-lg animate-fadeIn">
                  <h1 class="text-2xl md:text-3xl lg:text-5xl font-bold text-white mb-4">chmura云宽带</h1>
                  <p class="text-base md:text-lg text-white mb-8">超高速·无限流量·智能加速</p>
                </div>
              </div>
            </div>
          </div>

          <!-- 轮播项2 - 云路由 -->
          <div class="carousel-item w-full h-full flex-shrink-0">
            <div class="relative h-full bg-gradient-to-r from-blue-900 to-cyan-900">
              <div class="absolute inset-0 overflow-hidden">
                <div class="absolute inset-0 bg-black opacity-30"></div>
                <img
                  src="https://picsum.photos/seed/cloud-router/1920/1080.jpg"
                  alt="云路由"
                  class="w-full h-full object-cover"
                />
              </div>
              <div class="container mx-auto px-4 h-full flex items-center relative z-10">
                <div class="max-w-lg animate-fadeIn">
                  <h1 class="text-2xl md:text-3xl lg:text-5xl font-bold text-white mb-4">chmura云智能网关</h1>
                  <p class="text-base md:text-lg text-white mb-8">智能组网·安全防护·稳定高速</p>
                </div>
              </div>
            </div>
          </div>

          <!-- 轮播项3 - 物联网卡 -->
          <div class="carousel-item w-full h-full flex-shrink-0">
            <div class="relative h-full bg-gradient-to-r from-cyan-900 to-green-900">
              <div class="absolute inset-0 overflow-hidden">
                <div class="absolute inset-0 bg-black opacity-30"></div>
                <img
                  src="https://picsum.photos/seed/iot-card/1920/1080.jpg"
                  alt="物联网卡"
                  class="w-full h-full object-cover"
                />
              </div>
              <div class="container mx-auto px-4 h-full flex items-center relative z-10">
                <div class="max-w-lg animate-fadeIn">
                  <h1 class="text-2xl md:text-3xl lg:text-5xl font-bold text-white mb-4">chmura云物联网卡</h1>
                  <p class="text-base md:text-lg text-white mb-8">万物互联·稳定可靠·智能管理</p>
                </div>
              </div>
            </div>
          </div>

          <!-- 轮播项4 - 云宽带2 -->
          <div class="carousel-item w-full h-full flex-shrink-0">
            <div class="relative h-full bg-gradient-to-r from-purple-900 to-pink-900">
              <div class="absolute inset-0 overflow-hidden">
                <div class="absolute inset-0 bg-black opacity-30"></div>
                <img
                  src="https://picsum.photos/seed/cloud-broadband-2/1920/1080.jpg"
                  alt="云宽带2"
                  class="w-full h-full object-cover"
                />
              </div>
              <div class="container mx-auto px-4 h-full flex items-center relative z-10">
                <div class="max-w-lg animate-fadeIn">
                  <h1 class="text-2xl md:text-3xl lg:text-5xl font-bold text-white mb-4">chmura云宽带+</h1>
                  <p class="text-base md:text-lg text-white mb-8">千兆网络·全屋覆盖·智能优化</p>
                </div>
              </div>
            </div>
          </div>

          <!-- 轮播项5 - 云路由2 -->
          <div class="carousel-item w-full h-full flex-shrink-0">
            <div class="relative h-full bg-gradient-to-r from-green-900 to-blue-900">
              <div class="absolute inset-0 overflow-hidden">
                <div class="absolute inset-0 bg-black opacity-30"></div>
                <img
                  src="https://picsum.photos/seed/cloud-router-2/1920/1080.jpg"
                  alt="云路由2"
                  class="w-full h-full object-cover"
                />
              </div>
              <div class="container mx-auto px-4 h-full flex items-center relative z-10">
                <div class="max-w-lg animate-fadeIn">
                  <h1 class="text-2xl md:text-3xl lg:text-5xl font-bold text-white mb-4">chmura云智能路由</h1>
                  <p class="text-base md:text-lg text-white mb-8">AI驱动·安全加密·无缝漫游</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 指示器 -->
      <div class="carousel-indicators absolute bottom-4 left-0 right-0 flex justify-center space-x-2">
        <button
          v-for="(item, index) in 5"
          :key="index"
          class="indicator w-3 h-3 rounded-full transition-all duration-300"
          :class="{ 'bg-white opacity-100 w-8': index === currentIndex, 'bg-white opacity-50': index !== currentIndex }"
          @click="goToSlide(index)"
        ></button>
      </div>

      <!-- 左右箭头 -->
      <!-- <button class="carousel-arrow left-4 absolute top-1/2 -translate-y-1/2 bg-white bg-opacity-20 hover:bg-opacity-50 text-white w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300" @click="prevSlide">
        <i class="fas fa-chevron-left"></i>
      </button>
      <button class="carousel-arrow right-4 absolute top-1/2 -translate-y-1/2 bg-white bg-opacity-20 hover:bg-opacity-50 text-white w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300" @click="nextSlide">
        <i class="fas fa-chevron-right"></i>
      </button> -->
    </div>
  </section>
</template>

<script>
import gsap from 'gsap';

export default {
  name: 'Carousel',
  data() {
    return {
      isMobile: false,
      currentIndex: 0,
      autoplayInterval: null
    };
  },
  mounted() {
    // 初始化设备检测
    this.checkDeviceType();
    // 添加窗口大小变化监听器
    window.addEventListener('resize', this.checkDeviceType);
    // 初始化轮播图动画
    this.initCarouselAnimations();
    // 启动自动播放
    this.startAutoplay();
  },
  beforeDestroy() {
    // 移除窗口大小变化监听器
    window.removeEventListener('resize', this.checkDeviceType);
    // 停止自动播放
    this.stopAutoplay();
  },
  methods: {
    checkDeviceType() {
      this.isMobile = window.innerWidth < 768;
    },
    initCarouselAnimations() {
      // 为轮播图内容添加淡入动画
      const fadeInElements = document.querySelectorAll('.animate-fadeIn');

      fadeInElements.forEach(element => {
        gsap.fromTo(
          element,
          { opacity: 0, y: 20 },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
            ease: 'power2.out'
          }
        );
      });
    },
    // 轮播控制方法
    goToSlide(index) {
      this.currentIndex = index;
      this.restartAutoplay();
    },
    prevSlide() {
      this.currentIndex = (this.currentIndex - 1 + 5) % 5;
      this.restartAutoplay();
    },
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % 5;
      this.restartAutoplay();
    },
    // 自动播放方法
    startAutoplay() {
      this.autoplayInterval = setInterval(() => {
        this.nextSlide();
      }, 3000);
    },
    stopAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
        this.autoplayInterval = null;
      }
    },
    restartAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }
  }
};
</script>

<style scoped>
.carousel-container {
  font-family: 'Arial', 'Microsoft YaHei', sans-serif;
}

.carousel-wrapper {
  width: 100%;
  height: 100%;
}

.carousel-items {
  width: 100%;
  height: 100%;
}

.carousel-item {
  width: 100%;
  height: 100%;
}

.carousel-indicators {
  z-index: 10;
}

.indicator {
  border: none;
  outline: none;
  cursor: pointer;
  background-color: white;
  opacity: 0.5;
  transition: all 0.3s ease;
}

.indicator:hover {
  opacity: 0.8;
}

.carousel-arrow {
  z-index: 10;
  border: none;
  outline: none;
  cursor: pointer;
  transition: all 0.3s ease;
}

.carousel-arrow:hover {
  background-color: rgba(255, 255, 255, 0.5);
}

.btn-primary {
  background-color: var(--primary-color);
  transition: all 0.3s ease;
  border: none;
  padding: 10px 20px;
  font-size: 16px;
  font-weight: 500;
}

.btn-primary:hover {
  background-color: var(--secondary-color);
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 82, 217, 0.3);
}

.btn-outline {
  background-color: transparent;
  color: white;
  border: 2px solid white;
  transition: all 0.3s ease;
  padding: 10px 20px;
  font-size: 16px;
  font-weight: 500;
}

.btn-outline:hover {
  background-color: rgba(255, 255, 255, 0.2);
  color: white;
  transform: translateY(-2px);
}
</style>
